// ** Redux
import { vendor } from "store/vendor";
import {
	clearUserSuspension,
	setUserSuspension,
} from "store/modules/global-user/global-user.slice";

// #####################################################

export default function updateSuspensionHeader(headers) {
	const header = headers ? headers["datezone-user-ban"] || null : null;

	if (header == null) {
		return;
	}

	try {
		const suspension = JSON.parse(Buffer.from(header, "base64").toString());

		// Sprawdzenie czy suspension ma prawidłową strukturę
		if (!suspension || typeof suspension !== "object") {
			return;
		}

		const globalUserState = vendor.store.getState().globalUser;
		const isBanFromState = globalUserState?.suspension?.duration > 0;

		if (!suspension.isBan && isBanFromState) {
			vendor.store.dispatch(clearUserSuspension());
			return;
		}

		if (suspension.banTo && typeof suspension.banTo === "number") {
			vendor.store.dispatch(
				setUserSuspension({
					to: suspension.banTo,
					code: suspension.banType,
					id: suspension.id,
					isBanForNewContent: suspension?.isBanForNewContent,
				})
			);
		}
	} catch (error) {
		// Silently fail if header parsing fails - nie logujemy w produkcji
		// ale zapobiegamy crashowi aplikacji
		return;
	}
}

// #####################################################
